import React from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FaCalendar } from "react-icons/fa";

import { Schedule } from "services/action";
import { formatDate } from "utilities/common";

import { LoadingScreen, EmptyScreen } from "ui/components";

const RiwayatAbsence = ({ tabKey }) => {
  const History = useHistory();
  const Dispatch = useDispatch();

  const StateLoading = useSelector(
    (state) => state?.Activity?.services["Schedule.GetReport"]
  );

  const [data, setData] = React.useState(null);
  const [isEmpty, setEmpty] = React.useState(false);

  const $onLoad = async () => {
    const req = await Dispatch(Schedule.$getReport(params()));

    if (req?.message === "success") {
      if (req?.data) {
        setData(req?.data);
        setEmpty(false);
      } else {
        setEmpty(true);
      }
    }
  };

  const params = () => {
    let query = {
      page: 1,
      limit: 100,
    };

    return query;
  };

  React.useEffect(() => {
    if (tabKey !== 'absence') {
      return
    }

    $onLoad();
  }, [tabKey]);

  if (StateLoading) {
    return <LoadingScreen />;
  }

  return (
    <div className="pb-5">
      {isEmpty ? (
        <EmptyScreen text="Data tidak ditemukan" />
      ) : (
        <div className="px-3 py-2">
          {data?.map((d, i) => (
            <div
              className="px-3 py-2 shipment mb-2 position-relative bg-white border border-1"
              onClick={() => {
                History.push({
                  pathname: `/riwayat/report/${d?.report_id}`,
                  state: {
                    tap_in: d?.tap_in,
                    tap_out: d?.tap_out,
                  },
                });
              }}
            >
              <div className='d-flex mb-2'>
                <div>
                  <FaCalendar size={15} color="#2f83ba" />
                </div>
                <div className="ps-2">
                  <div className="fw-bold">
                    {formatDate(d?.schedule_date, 'DD/MM/YYYY')}
                  </div>
                </div>
              </div>
              <div className='row'>
                <div className='col-7 fw-semibold'>
                  Clockin
                  <span className='d-block fw-normal'>
                    {formatDate(d?.tap_in, 'DD/MM/YYYY HH:mm')}
                  </span>
                </div>
                <div className='col-5 fw-semibold'>
                  Clockout
                  <span className='d-block fw-normal'>
                    {d?.tap_out === '0001-01-01T00:00:00Z' ? '-' : formatDate(d?.tap_out, 'DD/MM/YYYY HH:mm')}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default RiwayatAbsence;
